/// <reference types="vite/client" />

type Environment = 'development' | 'production' | 'staging' | 'dev' | 'prod';

/**
 * Normalize environment string to standard format
 */
const normalizeEnv = (env: string): Environment => {
  const normalized = env.toLowerCase() as Environment;
  switch (normalized) {
    case 'dev':
    case 'development':
      return 'development';
    case 'prod':
    case 'production':
      return 'production';
    case 'staging':
      return 'staging';
    default:
      console.warn(`Unknown environment: ${env}, defaulting to development`);
      return 'development';
  }
};

/**
 * Environment helper functions
 */
export const isProduction = (): boolean => normalizeEnv(import.meta.env.VITE_ENV || 'development') === 'production';
export const isDevelopment = (): boolean => normalizeEnv(import.meta.env.VITE_ENV || 'development') === 'development';
export const isStaging = (): boolean => normalizeEnv(import.meta.env.VITE_ENV || 'development') === 'staging';

// Debug mode state management
let debugModeEnabled = isDevelopment() ? localStorage.getItem('debugModeEnabled') === 'true' : false;

export const isDebugMode = () => isDevelopment() && debugModeEnabled;
export const toggleDebugMode = () => {
  debugModeEnabled = !debugModeEnabled;
  if (isDevelopment()) {
    localStorage.setItem('debugModeEnabled', debugModeEnabled.toString());
  }
  window.dispatchEvent(new Event('debug-mode-change'));
  return debugModeEnabled;
};

/**
 * Type-safe environment variables
 */
export const env = {
  PROPELAUTH_URL: import.meta.env.VITE_PROPELAUTH_URL as string,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN as string,
  ENV: normalizeEnv(import.meta.env.VITE_ENV || 'development'),
  API_URL: isProduction() ? (import.meta.env.VITE_PROD_API_URL || window.location.origin) : (import.meta.env.VITE_API_URL || 'http://localhost:8000'),
  R2_PUBLIC_URL: isProduction() ? 'https://image.savida.ai' : 'https://pub-cf46a552036446debdde384b7daff870.r2.dev',
  get DEBUG_MODE() { return isDebugMode(); },
} as const; 